import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from './pipes.module';
import { loginComponent } from '../views/login/login.component';
import { mainViewComponent } from '../views/main-view/main-view.component';
import { EmpresasComponent } from '../views/empresas/empresas.component';
import { pluginsModule } from './plugins.module';
import { ConductoresComponent } from '../views/conductores/conductores.component';
import { VehiculosComponent } from '../views/vehiculos/vehiculos.component';
import { BsModalModule } from 'ng2-bs3-modal';
import { TipoServicioComponent } from '../views/tipoServicio/tipoServicio.component';
import { ClientesComponent } from '../views/clientes/clientes.component';
import { UsuariosComponent } from '../views/usuarios/usuarios.component';
import { ConfiguracionesComponent } from '../views/configuraciones/configuraciones.component';
import { RecargaReporte } from '../views/recargaReporte/recargaReporte.component';
import { ServicioReporte } from '../views/servicioReporte/servicioReporte.component';
import { GeolocalizacionComponent } from '../views/geolocalizacion/geolocalizacion.component';
import { cambiarClaveComponent } from '../views/cambiarClave/cambiarClave.component';
import { recuperarClaveComponent } from '../views/recuperarClave/recuperarClave.component';
import { verificarEmailComponent } from '../views/verificarEmail/verificarEmail.component';
import {Select2Component} from 'angular-select2-component';
import { ConductorReporte } from '../views/conductorReporte/conductorReporte.component';
import { ClienteReporte } from '../views/clienteReporte/clienteReporte.component';
import { EstadisticasReporte } from '../views/estadisticasReporte/estadisticasReporte.component';
@NgModule({
    imports: [
        FormsModule, CommonModule,  PipesModule, pluginsModule, BsModalModule
    ],
    declarations: [
         // Views
        loginComponent,
        mainViewComponent,
        EmpresasComponent,
        ConductoresComponent,
        VehiculosComponent,
        TipoServicioComponent,
        ClientesComponent,
        UsuariosComponent,
        ConfiguracionesComponent,
        RecargaReporte,
        ServicioReporte,
        ConductorReporte,
        ClienteReporte,
        EstadisticasReporte,
        GeolocalizacionComponent,
        cambiarClaveComponent,
        recuperarClaveComponent,
        verificarEmailComponent,
        Select2Component
    ],
    providers: [],
})
export class viewsModule { }


// WEBPACK FOOTER //
// ./src/app/modules/view.module.ts